<!-- Feature Selection Modal -->
<nz-modal [(nzVisible)]="isFeatureModalVisible" [nzTitle]="'Select Feature'"
    (nzOnCancel)="isFeatureModalVisible = false" [nzWidth]="600" [nzFooter]="null">
    <ng-container *nzModalContent>
        <nz-spin [nzSpinning]="isLoading">
            <div class="mb-4">
                <p class="text-gray-600">Select a feature to configure for this customer:</p>
            </div>

            <div class="feature-list">
                <div *ngFor="let feature of features; trackBy: trackByFeatureId"
                    class="feature-item p-4 mb-3 border border-gray-200 rounded-lg cursor-pointer hover:border-primary hover:bg-blue-50 transition-all"
                    [ngClass]="{ 'border-green-500 bg-green-50': isFeatureActive(feature) }"
                    (click)="onFeatureSelect(feature)">
                    <div class="flex justify-between items-start">
                        <div class="flex-1">
                            <h3 class="text-lg font-semibold mb-1"
                                [ngClass]="isFeatureActive(feature) ? 'text-green-700' : 'text-gray-800'">
                                {{ feature.name }}
                            </h3>
                            <p class="text-gray-600 text-sm">{{ feature.description }}</p>
                        </div>
                        <div class="flex items-center gap-2">
                            <nz-tag *ngIf="isFeatureActive(feature)" nzColor="green">
                                Active
                            </nz-tag>
                            <i nz-icon nzType="right" class="text-gray-400 ml-1"></i>
                        </div>
                    </div>
                </div>

                <div *ngIf="features.length === 0 && !isLoading" class="text-center py-8 text-gray-500">
                    <i nz-icon nzType="inbox" class="text-4xl mb-2"></i>
                    <p>No features available</p>
                </div>
            </div>
        </nz-spin>
    </ng-container>
</nz-modal>

<!-- Feature Form Modal -->
<nz-modal [(nzVisible)]="isFeatureFormVisible"
    [nzTitle]="selectedFeature ? 'Configure ' + selectedFeature.name : 'Configure Feature'"
    (nzOnCancel)="closeFeatureForm()" [nzWidth]="800" [nzFooter]="null">
    <ng-container *nzModalContent>
        <app-feature-form [feature]="selectedFeature" [customerId]="customerId"
            (formSubmit)="onFeatureFormSubmit($event)" (formCancel)="closeFeatureForm()">
        </app-feature-form>
    </ng-container>
</nz-modal>